import type { FC } from "react";

import { useSelector } from "react-redux";

import { translate } from "app/filters/i18nFilter";
import type { TableActionProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import {
    AssignToUserModal,
    selectIsShowAssignToUserModal,
    AssignToOtherUsersButtonClaimContainer,
} from "app/pages/sales-intelligence/sub-modules/assign-to-users";
import type { Translatable } from "app/pages/sales-intelligence/types";

import { selectActiveLeadsType, selectIsTableRowExpanded } from "../../../store/selectors";

import { COMPANY_ASSIGN_TO_USER_MODAL_TITLE, TOOLTIP_I18N_KEYS, WEBSITE_ASSIGN_TO_USER_MODAL_TITLE } from "./const";

type Props = {
    onClick: VoidFunction;
} & TableActionProps;

const AssignToUserButtonContainer: FC<Props> = ({ isDisabled, onClick }) => {
    const isShowAssignToUserModal = useSelector(selectIsShowAssignToUserModal);
    const isTableRowExpanded = useSelector(selectIsTableRowExpanded);
    const activeSearchLeadsType = useSelector(selectActiveLeadsType);

    const modalTitleTranslatable: Translatable =
        activeSearchLeadsType === "companies" ? COMPANY_ASSIGN_TO_USER_MODAL_TITLE : WEBSITE_ASSIGN_TO_USER_MODAL_TITLE;

    const getTooltipContent = (): string => {
        let i18nKey: string;

        switch (true) {
            case isTableRowExpanded:
                i18nKey = TOOLTIP_I18N_KEYS.innerTableKey;
                break;

            case activeSearchLeadsType === "companies":
                i18nKey = TOOLTIP_I18N_KEYS.companyKey;
                break;

            default:
                i18nKey = TOOLTIP_I18N_KEYS.websiteKey;
        }

        return translate(i18nKey);
    };

    return (
        <>
            <AssignToUserModal
                isOpen={isShowAssignToUserModal}
                titleTranslatable={modalTitleTranslatable}
            />
            <AssignToOtherUsersButtonClaimContainer
                isDisabled={isDisabled || isTableRowExpanded}
                isTooltipDisabled={isDisabled}
                tooltipContent={getTooltipContent()}
                onClick={onClick}
            />
        </>
    );
};

export default AssignToUserButtonContainer;
